var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06065 2.26973L0.71875 4.53951L3.07225 6.82015L5.42575 9.10079L5.92328 8.62031L6.42077 8.13987L4.91818 6.68278L3.41558 5.22573L10.1109 5.23834L16.8063 5.2509L17.1529 5.3548C18.4246 5.73584 19.441 6.57906 19.9564 7.68052C20.2426 8.2921 20.3079 8.61779 20.3058 9.42263C20.3044 9.98326 20.2839 10.2266 20.2189 10.4543C19.7975 11.9305 18.7141 13.0045 17.1811 13.4659L16.759 13.5929L13.8608 13.6078L10.9626 13.6226V14.3113V15L13.8371 14.9815C16.599 14.9638 16.7301 14.9591 17.1821 14.861C18.9341 14.4809 20.347 13.4177 21.1463 11.878C21.5577 11.0853 21.7166 10.4039 21.7187 9.42263C21.7205 8.60857 21.6484 8.19948 21.3747 7.46997C20.7984 5.93355 19.4023 4.638 17.7763 4.13069C16.9205 3.86369 17.3929 3.88079 10.1225 3.85365L3.43862 3.82866L4.92915 2.38486L6.41968 0.941025L5.93577 0.470535C5.66966 0.211746 5.44079 0 5.42721 0C5.41363 0 4.34867 1.0214 3.06065 2.26973Z",
    fill: "#E6581F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOrange);
export default __webpack_public_path__ + "static/media/back-orange.8e19278d1669d5a0dc6500eb01e8b9b3.svg";
export { ForwardRef as ReactComponent };